import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import PredefinedDateRangesOneMonth from "../../../core/common/datePickerOneMonth";
import Table from "../../../core/common/dataTable/index";
import api from "../../../services/api";
import Loader from "../../../core/common/loader";
import { showBasicAlert } from "../../../core/common/useAlert";
import jsPDF from "jspdf";
import { Select } from "antd";
import * as XLSX from "xlsx";
import { useLocation, useNavigate } from "react-router-dom";
import { getAbbreviation } from "../../../core/common/common_functions";
import moment from "moment";
import CommonSelect from "../../../core/common/commonSelect";
import { Menu, MenuItem, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import EditLead from "./editLead";

interface FormField {
  id: string;
  label: string;
  type: "text" | "select";
  options?: string[];
}

interface FormData {
  structure: FormField[];
  responses?: { [key: string]: string };
}

const DealsList = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const user = useSelector((state: any) => state.user.user);

  let previousSelectedCompanyDetails = location.state?.companyDetails || null;
  let previousSelectedformDetails = location.state?.formDetails || null;

  const { Option } = Select;
  const signature = localStorage.getItem("signature");
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<any[]>([]);
  const [filteredData, setFilteredData] = useState(data);
  const [users, setUsers] = useState<any[]>([]);

  const [getAllCompanyLists, setgetAllCompanyList] = useState<any[]>([]);
  const [dataForm, setdataForm] = useState<any[]>([]);
  const [pipelines, setPipelines] = useState<any[]>([]); // Pipeline Stages (e.g., Not Contacted, Contacted)

  const [HeaderGrid, setHeaderGrid] = useState<any>({}); // References for Dragula

  const [filterPopup, setFilterPopup] = useState(false);
  const [activeFilter, setActiveFilter] = useState("date");

  const companyChoose = [
    ...getAllCompanyLists?.map((company: any) => ({
      value: company.id,
      label: company.name + " - " + company.type,
    })),
  ];

  var initialFormDataChooseCompany = {
    signature: signature,
    companyName: "Select Company",
    companyId: "",
    companyType: "Deals",
  };
  const [formDataCompanyChoose, setformDataCompanyChoose] = useState(
    initialFormDataChooseCompany
  );

  const handleCompanyChange = async (selectedOption: any) => {
    if (
      !selectedOption ||
      selectedOption.value == "" ||
      selectedOption.value == undefined
    )
      return;

    const newFormData = {
      companyId: selectedOption.value,
      companyName: selectedOption.label.split("-")[0].trim(),
      companyType: selectedOption.label.split("-")[1].trim(),
    };

    setformDataCompanyChoose((prev: any) => ({
      ...prev,
      ...newFormData,
    }));

    try {
      const [getLeadForms] = await Promise.all([
        api.post("leadService/getLeadFormsByCompany", {
          signature,
          company_id: newFormData.companyId,
          company_type: newFormData.companyType,
        }),
      ]);
      setdataForm(getLeadForms.data.data.data);
    } catch (err) {
      console.error("Error fetching dashboard data:", err);
    }
  };

  useEffect(() => {
    if (
      dataForm.length &&
      previousSelectedformDetails &&
      previousSelectedformDetails != null
    ) {
      handleFormChange({
        value:
          previousSelectedformDetails?.pipeline_id +
          "-" +
          previousSelectedformDetails?.form_id,
        label: previousSelectedformDetails?.form_name,
      });

      handleUserChange({
        value: previousSelectedformDetails?.user_id,
        label: previousSelectedformDetails?.user_name,
      });
    } else if (dataForm.length) {
      handleFormChange({
        value: dataForm[0].deal_pipeline_id + "-" + dataForm[0].key,
        label: dataForm?.[0]?.LeadFormName,
      });
    } else {
      handleFormChange({
        value: "",
        label: "No Lead Form",
      });
      setIsLoading(false);
    }
  }, [dataForm]);

  const formChoose = [
    ...dataForm?.map((form: any) => ({
      value: form.deal_pipeline_id + "-" + form.key,
      label: form.LeadFormName,
    })),
  ];

  const userChoose = [
    { value: "0", label: "All Employees" },
    ...users?.map((usr: any) => ({
      value: usr.key,
      label: usr.Name,
    })),
  ];

  var initialFormDataChooseForm = {
    signature: signature,
    pipeline_id: "Select Form",
    form_name: "",
    form_id: "",
    user_id: "0",
    user_name: "All Employees",
  };
  const [formDataFormChoose, setformDataFormChoose] = useState(
    initialFormDataChooseForm
  );

  const handleFormChange = async (selectedOption: any) => {
    if (!selectedOption || selectedOption.value == "") {
      const newFormData = {
        pipeline_id: selectedOption.value?.split("-")[0],
        form_name: selectedOption.label,
        form_id: selectedOption.value?.split("-")[1],
      };
      setformDataFormChoose((prev: any) => ({
        ...prev,
        ...newFormData,
      }));
      return;
    }
    const newFormData = {
      pipeline_id: selectedOption.value?.split("-")[0],
      form_name: selectedOption.label,
      form_id: selectedOption.value?.split("-")[1],
    };
    setformDataFormChoose((prev: any) => ({
      ...prev,
      ...newFormData,
    }));

    try {
      const [pipelineList] = await Promise.all([
        api.post("leadService/getAllPipelinesById", {
          signature,
          id: newFormData.pipeline_id,
        }),
      ]);
      setPipelines(pipelineList.data.data.data);

      navigate(
        {
          pathname: location.pathname,
          search: location.search,
        },
        {
          replace: true,
          state: {
            ...location.state,
            companyDetails: undefined,
            formDetails: undefined,
          },
        }
      );
    } catch (err) {
      console.error("Error fetching dashboard data:", err);
    }
  };

  useEffect(() => {
    updateUI(formDataCompanyChoose);
  }, [formDataFormChoose, pipelines]);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setIsLoading(true);
        const [getAllCompanyList] = await Promise.all([
          api.post("userService/getAllCompanyList", { signature }),
        ]);
        var finalCompanyList: any = [];
        for (let i = 0; i < getAllCompanyList.data.data.data.length; i++) {
          const [getLeadForms] = await Promise.all([
            api.post("leadService/getLeadFormsByCompany", {
              signature,
              company_id: getAllCompanyList.data.data.data[i].id,
              company_type: getAllCompanyList.data.data.data[i].type,
            }),
          ]);

          let dealForms = [];
          for (let j = 0; j < getLeadForms?.data?.data?.data?.length; j++) {
            const item = getLeadForms.data.data.data[j];
            if (
              item.deal_pipeline_id != null &&
              item.deal_pipeline_id != "" &&
              item.deal_pipeline_id != undefined
            ) {
              dealForms.push(item);
            }
          }

          if (dealForms.length > 0) {
            finalCompanyList.push(getAllCompanyList.data.data.data[i]);
          }
        }
        setgetAllCompanyList(finalCompanyList);
      } catch (err) {
        console.error("Error fetching dashboard data:", err);
      }
    };

    fetchDashboardData();
  }, []);

  useEffect(() => {
    if (previousSelectedCompanyDetails != null) {
      handleCompanyChange({
        value: previousSelectedCompanyDetails?.companyId,
        label:
          previousSelectedCompanyDetails?.companyName +
          "-" +
          previousSelectedCompanyDetails?.companyType,
      });
    } else {
      handleCompanyChange({
        value: getAllCompanyLists?.[0]?.id,
        label:
          getAllCompanyLists?.[0]?.name + "-" + getAllCompanyLists?.[0]?.type,
      });
    }
  }, [getAllCompanyLists]);

  const updateUI = async (data: any) => {
    if (
      data.companyId == "" ||
      pipelines.length == 0 ||
      formDataFormChoose.form_id == "" ||
      formDataFormChoose.form_id == undefined
    ) {
      setData([]);
      setFilteredData([]);
      return;
    }
    setIsLoading(true);
    var fetchedLeads;
    var getLeadSettings;
    const selectedLabel = location.state?.selectedLabel;
    if (selectedLabel) {
      try {
        setIsLoading(true);
        [fetchedLeads] = await Promise.all([
          api.post("leadService/getAllDealsResponseBypipeline", {
            signature,
            char: selectedLabel,
            type: location.state?.type,
          }),
        ]);
        var response = fetchedLeads.data.data.data;
        setData(response);
        setFilteredData(response);
      } catch (err) {
        console.error("Error fetching dashboard data:", err);
      }
    } else {
      [fetchedLeads, getLeadSettings] = await Promise.all([
        api.post("leadService/getAllDealsResponse", {
          signature,
          company_id: data.companyId,
          company_type: data.companyType,
          start_date: moment(selectedStartDate.toDate()).format("YYYY-MM-DD"),
          end_date: moment(selectedEndDate.toDate()).format("YYYY-MM-DD"),
          form_id: formDataFormChoose.form_id,
          ...(formDataFormChoose.user_id !== "0" && {
            user_id: formDataFormChoose.user_id,
          }),
        }),
        api.post("leadService/getAllLeadSettings", {
          signature,
          company_id: parseInt(formDataCompanyChoose.companyId),
          company_type: formDataCompanyChoose.companyType,
        }),
      ]);

      const [responseUser] = await Promise.all([
        api.post("userService/getLeadEmployeesListData", {
          signature,
          department:
            getLeadSettings?.data?.data?.data[0]?.settings
              ?.lead_assigned_to_department || -1,
          company_id: parseInt(formDataCompanyChoose.companyId),
          company_type: formDataCompanyChoose.companyType,
        }),
      ]);
      setUsers(responseUser.data?.data?.data?.allUsers || []);

      var response = fetchedLeads.data.data.data;
      const filteredLeads = response.filter(
        (item: any) =>
          parseInt(item.pipeline_id) ===
          parseInt(formDataFormChoose.pipeline_id)
      );
      setData(filteredLeads);
      setFilteredData(filteredLeads);
    }

    const totalLeads = location.state?.totalLeads;
    if (totalLeads) {
      const today = moment();
      setSelectedStartDate(today);
      setSelectedEndDate(today);
    }

    const details = location.state?.details;
    if (details) {
      var result = response.filter(
        (item: any) => parseInt(item.key) === parseInt(details)
      );
      result = result[0];
      const filteredPipelines = pipelines.filter(
        (item: any) =>
          item.Company_Type?.trim() === result.company_type?.trim() &&
          parseInt(item.Company_Id) === parseInt(result.company_id) &&
          item.Type === "deal"
      );
      // Extract Stages from the first matching pipeline or default to []
      const stages = filteredPipelines?.[0]?.Stages || [];
      navigate(routes.leadsDetails, {
        state: {
          lead: result,
          data: dataForm,
          pipelines: stages,
          type: "deal_list",
          selectedCompanyDetails: formDataCompanyChoose,
          selectedLeadFormDetails: formDataFormChoose,
        },
      });
    }

    const leadStats = Object.entries(
      fetchedLeads?.data.data.data[0]?.Items || {}
    ).map(([key, value]: any) => {
      let icon = "";
      let color = "";
      let progressColor = "";

      // Assign fixed values based on key
      switch (key) {
        case "Total Deals":
          icon = "ti-stack-middle";
          color = "bg-primary";
          progressColor = "bg-primary";
          break;
        case "Today’s Deals":
          icon = "ti-calendar";
          color = "bg-success";
          progressColor = "bg-success";
          break;
        case "Yesterday’s Deals":
          icon = "ti-calendar-event";
          color = "bg-warning";
          progressColor = "bg-warning";
          break;
        case "This Month’s Deals":
          icon = "ti-calendar-month";
          color = "bg-info";
          progressColor = "bg-info";
          break;
        default:
          icon = "ti-briefcase"; // Fallback icon
          color = "bg-secondary";
          progressColor = "bg-secondary";
      }

      return {
        title: key,
        value: value,
        icon,
        color,
        progressColor,
      };
    });
    setHeaderGrid(leadStats);
    setIsLoading(false);
  };

  const [selectedStartDate, setSelectedStartDate] = useState<moment.Moment>(
    moment().subtract(29, "days")
  );
  const [selectedEndDate, setSelectedEndDate] = useState<moment.Moment>(
    moment()
  );

  useEffect(() => {
    updateUI(formDataCompanyChoose);
  }, [selectedStartDate, selectedEndDate]);

  const handleDateChange = (start: moment.Moment, end: moment.Moment) => {
    setSelectedStartDate(start);
    setSelectedEndDate(end);
  };
  const handleStageChange = async (value: any, record: any) => {
    try {
      await api.post("leadService/updateDealResponsePipeline", {
        signature,
        pipeline: value,
        lead_id: record.key,
      });
      refreshPage();
    } catch (err) {
      console.error("Error updating lead pipeline:", err);
    }
  };
  const routes = all_routes;
  const columns = [
    {
      title: "Deal Id",
      dataIndex: "lead_id",
    },
    {
      title: "Deal Name",
      dataIndex: "LeadName",
      render: (text: string, record: any) => {
        // Filter the pipelines based on the record
        const filteredPipelines = pipelines.filter(
          (item: any) =>
            item.Company_Type?.trim() === record.company_type?.trim() &&
            parseInt(item.Company_Id) === parseInt(record.company_id) &&
            item.Type === "deal"
        );
        // Extract Stages from the first matching pipeline or default to []
        const stages = filteredPipelines?.[0]?.Stages || [];
        return (
          <h6 className="fw-medium fs-14">
            <Link
              to={`${routes.leadsDetails}${location?.search}`}
              state={{
                lead: record,
                data: dataForm,
                pipelines: stages,
                type: "deal_list",
                selectedCompanyDetails: formDataCompanyChoose,
                selectedLeadFormDetails: formDataFormChoose,
              }}>
              {text}
            </Link>
          </h6>
        );
      },
      sorter: (a: any, b: any) => a.LeadName.length - b.LeadName.length,
    },
    {
      title: "Phone",
      dataIndex: "Phone",
    },

    {
      title: "Pipeline",
      dataIndex: "Pipeline",
      sorter: (a: any, b: any) => {
        // Compare pipeline_char values
        if (a.pipeline_char < b.pipeline_char) return -1;
        if (a.pipeline_char > b.pipeline_char) return 1;
        return 0;
      },
      render: (text: any, record: any) => {
        const currentColor =
          pipelines[0]?.Color?.[
          pipelines[0]?.Stages?.indexOf(record.pipeline_char)
          ] || "#000000";

        return (
          <Select
            defaultValue={record.pipeline_char}
            onChange={(value: any) => handleStageChange(value, record)}
            style={{
              width: 150,
              backgroundColor: currentColor,
              border: `3px solid ${currentColor}`,
              color: "#fff",
              paddingLeft: "24px",
              position: "relative",
            }}
            dropdownStyle={{ backgroundColor: "#fff" }}>
            {text.map((stage: any) => (
              <Option key={stage} value={stage}>
                <span className="badge-info-transparent">{stage}</span>
              </Option>
            ))}
          </Select>
        );
      },
    },
    {
      title: "CreatedDate",
      dataIndex: "CreatedDate",
      sorter: (a: any, b: any) => a.CreatedDate.length - b.CreatedDate.length,
    },
    {
      title: "Assigned To",
      dataIndex: "assigned_to_name",
      sorter: (a: any, b: any) =>
        a.assigned_to_name.length - b.assigned_to_name.length,
    },
    {
      title: "More Detail",
      dataIndex: "actions",
      render: (text: string, record: any) => {
        // Filter the pipelines based on the record
        const filteredPipelines = pipelines.filter(
          (item: any) =>
            item.Company_Type?.trim() === record.company_type?.trim() &&
            parseInt(item.Company_Id) === parseInt(record.company_id) &&
            item.Type === "lead"
        );
        // Extract Stages from the first matching pipeline or default to []
        const stages = filteredPipelines?.[0]?.Stages || [];
        return (
          <h6 className="fw-medium fs-14">
            <Link
              to={`${routes.leadsDetails}${location?.search}`}
              state={{
                lead: record,
                data: dataForm,
                pipelines: stages,
                type: "deal_list",
                selectedCompanyDetails: formDataCompanyChoose,
                selectedLeadFormDetails: formDataFormChoose,
              }}
              className="text-decoration-underline">
              Click here
            </Link>
          </h6>
        );
      },
    },
    {
      title: "Edit",
      render: (text: string, lead: any) => {
        // Filter the pipelines based on the record
        return (
          <div className="ms-auto">
            <IconButton
              aria-label="edit"
              onClick={(event) =>
                handleMenuOpen(event, {
                  structure: dataForm.find(
                    (item) => parseInt(item.key) === parseInt(lead.form_id)
                  )?.structure,
                  responses: lead.response,
                  id: lead.key,
                })
              }>
              <EditIcon fontSize="small" />
            </IconButton>

            {/* Dropdown Menu */}
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}>
              <MenuItem onClick={handleEditLead}>Edit Deal</MenuItem>
            </Menu>
          </div>
        );
      },
    },
  ];

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [selectedLead, setSelectedLead] = useState<FormData | null>(null);

  const handleMenuOpen = (event: any, lead: any) => {
    setAnchorEl(event.currentTarget);
    setSelectedLead(lead);
  };

  // Function to handle menu close
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // Function to open EditLead modal
  const handleEditLead = () => {
    setIsEditOpen(true);
    handleMenuClose();
  };

  // Function to close EditLead modal
  const handleCloseEdit = () => {
    refreshPage();
    setIsEditOpen(false);
  };
  const [sortBy, setSortBy] = useState<string>("Last 7 Days");

  useEffect(() => {
    if (filteredData) {
      var newFilteredData = data
        .filter((item: any) => {
          // Apply date range filter (if dates are selected)
          if (selectedStartDate && selectedEndDate) {
            const createdDate = new Date(item.CreatedDate);

            // Convert moment objects to Date objects if needed
            const startDate =
              selectedStartDate instanceof Date
                ? selectedStartDate
                : selectedStartDate.toDate();
            const endDate =
              selectedEndDate instanceof Date
                ? selectedEndDate
                : selectedEndDate.toDate();

            // Check if the created date is within the selected date range
            if (createdDate < startDate || createdDate > endDate) {
              return false;
            }
          }
          return true;
        })
        .sort((a: any, b: any) => {
          switch (sortBy) {
            case "Recently Added":
              return (
                new Date(b.CreatedDate).getTime() -
                new Date(a.CreatedDate).getTime()
              );
            case "Ascending(Company)":
              return a.CompanyName.localeCompare(b.CompanyName);
            case "Descending(Company)":
              return b.CompanyName.localeCompare(a.CompanyName);
            case "Ascending(Name)":
              return a.LeadName.localeCompare(b.LeadName);
            case "Descending(Name)":
              return b.LeadName.localeCompare(a.LeadName);
            case "Last Month":
              const oneMonthAgo = new Date();
              oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1); // Get the date for one month ago
              const lastMonthCreatedDate =
                new Date(b.CreatedDate).getTime() -
                new Date(a.CreatedDate).getTime();

              // If the created date is within the last month, continue sorting by CreatedDate
              if (
                new Date(b.CreatedDate) >= oneMonthAgo &&
                new Date(a.CreatedDate) >= oneMonthAgo
              ) {
                return lastMonthCreatedDate;
              } else {
                return 0; // Do not change order if dates are not within the last month
              }
            case "Last 7 Days":
              const sevenDaysAgo = new Date();
              sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7); // Get the date for 7 days ago
              const last7DaysCreatedDate =
                new Date(b.CreatedDate).getTime() -
                new Date(a.CreatedDate).getTime();

              // If the created date is within the last 7 days, continue sorting by CreatedDate
              if (
                new Date(b.CreatedDate) >= sevenDaysAgo &&
                new Date(a.CreatedDate) >= sevenDaysAgo
              ) {
                return last7DaysCreatedDate;
              } else {
                return 0; // Do not change order if dates are not within the last 7 days
              }

            default: // 'Last 7 Days'
              return (
                new Date(b.CreatedDate).getTime() -
                new Date(a.CreatedDate).getTime()
              ); // Adjust logic for 'Last 7 Days'
          }
        });
      var dateFilter = [...newFilteredData];
      if (dateFilter.length > 0) {
        setFilteredData(dateFilter); // Update filtered data
      } else {
        if (data.length > 0) {
          setFilteredData([]);
          showBasicAlert("No Data");
        }
      }
    }
  }, [sortBy, selectedStartDate, selectedEndDate]);

  const handleExportPDF = () => {
    const doc = new jsPDF();

    // Example columns
    const columns = [
      "Deal Name",
      "Company Type",
      "Phone",
      "Email",
      "Stage",
      "Date",
      "Deal Owner",
    ];
    const tableData: (string | number)[][] = filteredData.map((item) => [
      item.LeadName,
      item.CompanyName,
      item.Phone,
      item.Email,
      item.Stage,
      item.createdAt,
      item.LeadName,
    ]);

    // Generate the table in the PDF (no need to pass `doc` as the first argument anymore)
    doc.autoTable({
      head: [columns],
      body: tableData,
    });

    // Save the PDF
    doc.save("leads.pdf");
  };
  const handleExportExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData); // Convert JSON to sheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    XLSX.writeFile(wb, "leads.xlsx");
  };

  const refreshPage = async () => {
    updateUI(formDataCompanyChoose);
  };

  const handleUserChange = async (selectedOption: any) => {
    if (!selectedOption || selectedOption.value == "") return;
    const newFormData = {
      user_id: selectedOption.value,
      user_name: selectedOption.label,
    };

    setformDataFormChoose((prev: any) => ({
      ...prev,
      ...newFormData,
    }));
  };

  return (
    <>
      {isLoading && <Loader />}
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">👤 Deals</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">CRM</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Deals List
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="dropdown me-2 mb-2">
                <CommonSelect
                  className="select"
                  options={formChoose}
                  defaultValue={{
                    value: `${formDataFormChoose.pipeline_id}-${formDataFormChoose.form_id}`,
                    label: formDataFormChoose.form_name,
                  }}
                  onChange={handleFormChange}
                />
              </div>

              <div className="dropdown me-2 mb-2">
                <CommonSelect
                  className="select"
                  options={companyChoose}
                  defaultValue={{
                    value: formDataCompanyChoose.companyId,
                    label:
                      formDataCompanyChoose.companyName +
                      "-" +
                      formDataCompanyChoose.companyType,
                  }}
                  onChange={handleCompanyChange}
                />
              </div>
              <div className="me-2 mb-2">
                <div className="d-flex align-items-center border bg-white rounded p-1 me-2 icon-list">
                  <Link
                    to={`${routes.dealsList}${location?.search}`}
                    className="btn btn-icon btn-sm active bg-primary text-white me-1">
                    <i className="ti ti-list-tree" />
                  </Link>
                  <Link
                    to={`${routes.dealsGrid}${location?.search}`}
                    state={{
                      companyDetails: formDataCompanyChoose,
                      formDetails: formDataFormChoose,
                    }}
                    className="btn btn-icon btn-sm">
                    <i className="ti ti-layout-grid" />
                  </Link>
                </div>
              </div>
              <div className="me-2 mb-2">
                <div className="dropdown">
                  <Link
                    to="#"
                    onClick={(e: any) => e.preventDefault()}
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown">
                    <i className="ti ti-file-export me-1" />
                    Export
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={(e: any) => {
                          e.preventDefault();
                          handleExportPDF();
                        }}>
                        <i className="ti ti-file-type-pdf me-1" />
                        Export as PDF
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={(e: any) => {
                          e.preventDefault();
                          handleExportExcel();
                        }}>
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel{" "}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Leads List */}
          <div>
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3 mb-4">
              <h5>Lead List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                {(user?.userDetails.role_char.toLowerCase() === "admin" ||
                  user?.userDetails.role_char.toLowerCase() ===
                  "employeeadmin") && (
                    <div className="dropdown me-2">
                      <CommonSelect
                        className="select"
                        options={userChoose}
                        defaultValue={{
                          value: formDataFormChoose.user_id,
                          label: formDataFormChoose.user_name,
                        }}
                        onChange={handleUserChange}
                      />
                    </div>
                  )}

                <div className="dropdown me-3">
                  <Link
                    to="#"
                    onClick={(e: any) => e.preventDefault()}
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown">
                    Sort By: {sortBy}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={(e: any) => {
                          e.preventDefault();
                          setSortBy("Recently Added");
                        }}>
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={(e: any) => {
                          e.preventDefault();
                          setSortBy("Ascending(Name)");
                        }}>
                        Ascending(Name)
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={(e: any) => {
                          e.preventDefault();
                          setSortBy("Descending(Name)");
                        }}>
                        Descending(Name)
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={(e: any) => {
                          e.preventDefault();
                          setSortBy("Last Month");
                        }}>
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={(e: any) => {
                          e.preventDefault();
                          setSortBy("Last 7 Days");
                        }}>
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="me-3">
                  <div className="input-icon-end position-relative">
                    <PredefinedDateRangesOneMonth
                      startDate={selectedStartDate}
                      endDate={selectedEndDate}
                      onDateChange={handleDateChange}
                    />
                    <span className="input-icon-addon">
                      <i className="ti ti-chevron-down" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-0">
              <div>
                <div className="row">
                  {filteredData.length > 0 &&
                    HeaderGrid.map((stat: any, index: any) => (
                      <div className="col-xl-3 col-md-6" key={index}>
                        <div
                          className="card position-relative border-0 shadow-sm h-60"
                          style={{
                            borderRadius: "12px",
                            overflow: "hidden",
                            transition: "all 0.3s",
                          }}>
                          <div className="card-body position-relative z-1 bg-white">
                            {/* Icon + Title + Value */}
                            <div className="d-flex align-items-center mb-3">
                              <div
                                className={`avatar avatar-md rounded-circle d-flex align-items-center justify-content-center ${stat.color}`}
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  background: stat.gradient || "#6366f1",
                                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                }}>
                                <i
                                  className={`ti ${stat.icon} text-white fs-20`}
                                />
                              </div>
                              <div className="ms-3">
                                <p className="fw-semibold text-muted mb-1 text-truncate">
                                  {stat.title}
                                </p>
                                <h5 className="mb-0 fw-bold text-dark">
                                  {stat.value}
                                </h5>
                              </div>
                            </div>

                            {/* Background Image Overlay */}
                            <span
                              className="position-absolute top-0 end-0 opacity-10"
                              style={{ zIndex: 0 }}>
                              <ImageWithBasePath
                                src="assets/img/bg/card-bg-04.png"
                                alt="bg"
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
              <Table
                key={JSON.stringify(filteredData)}
                dataSource={filteredData}
                columns={columns}
                Selection={false}
              />
            </div>
          </div>
          {/* /Leads List */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2025 © CMS.</p>
          <p>
            Designed & Developed By{" "}
            <Link
              to="#"
              onClick={(e: any) => e.preventDefault()}
              className="text-primary">
              ZYVO
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
      {selectedLead && (
        <EditLead
          open={isEditOpen}
          onClose={handleCloseEdit}
          updateUI={() => { }}
          data={[selectedLead]}
        />
      )}
    </>
  );
};

export default DealsList;
